<template>
	<div class="addVirtualWallet">
		<div class="settingwarp">
			<header>
				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>{{$t('anquan1')}}</div>
							</div>
							<div class="action" @click="changego">
								<text class="cuIcon-back" style="width: 50px;">
									<span></span>
								</text>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div class="g-content">
				<!-- 第一次设置安全码显示这个 -->
				<!-- <template>
					<div class="form-wrapper is-not-set">
						<div class="lock-bg">
							<div class="paycode">
								<van-password-input :value="new_code" :focused="showKeyboard"
									@focus="showKeyboard = true" />
								<van-number-keyboard v-model="new_code" :show="showKeyboard"
									@blur="showKeyboard = false" />
							</div>
							<p class="c_a0a0a0" style="font-size: 0.4rem">
								{{$t('anquanmaTps')}}
							</p>
						</div>
						<div class="tips">
							<img src="@/assets/image/tishi.png" alt="" />
							<span class="c_a0a0a0">{{$t('anquanmaTpsTow')}}</span>
						</div>
					</div>
				</template> -->
				<!-- 后续修改安全码显示这个 -->
				<div class="form">
					<van-field v-model="after_code" :placeholder="$t('planquanma')">
						<template #label>
							<span class="addtitle">{{$t('yuananquanma')}}</span>
						</template>
					</van-field>
					<van-field v-model="new_code"  :placeholder="$t('plxinanquanma')">
						<template #label>
							<span class="addtitle">{{$t('xinanquanma')}}</span>
						</template>
					</van-field>
					<van-field v-model="new_codeOk" :placeholder="$t('plquerenmima')">
						<template #label>
							<span class="addtitle">{{$t('querenmima')}}</span>
						</template>
					</van-field>
				</div>
				<div class="finish-btn">
					<van-button type="primary" round block class="Btnlogin"
						@click="setSafety">{{$t('queren')}}</van-button>
				</div>
			</div>
		</div>
		<alert-pop :alertType="3" :Tips="TipsTxt" v-if="PopAlert" @showAletfalse="showAletfalse"></alert-pop>
	</div>
</template>
<script>
	import AlertPop from "@/components/alert/AlertPop.vue";
	import userApi from "@/api/user";
	export default {
		name: "AddVirtualWallet",
		components: {
			AlertPop,
		},
		data() {
			return {
				PopAlert: false,
				setCode: null,
				showKeyboard: true,
				value: "",
				new_code: "",
				new_codeOk: "",
				after_code: "",
				TipsTxt: this.$t('Tips.szcg'),
			};
		},
		watch: {
			new_code(value) {
				if (value.length === 6 && this.setCode == "false") {
					// 调用接口
					this.showKeyboard = false;
					this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 300,
					});

					userApi
						.setSafety(this.new_code, this.after_code)
						.then((data) => {
							console.log(data.data);
							this.PopAlert = true;
						})
						.catch((err) => {
							this.$toast.fail(err.msg);
						});
				}
			},
		},
		methods: {
			showAletfalse() {
				this.PopAlert = false;
				this.$router.go(-1);
			},
			changego() {
				this.$router.go(-1);
			},
			setSafety() {
				if (!this.after_code) {
					this.$toast(this.$t('planquanma'));
				} else if (!this.new_code && this.setCode) {
					this.$toast("plxinanquanma");
				} else if (!(this.new_code)|| this.new_code < 6 || this.new_code > 20) {
					this.$toast(this.$t('aqqewad'));
				} else if (!this.new_codeOk) {
					this.$toast(this.$t('plquerenmima'));
				} else if (this.new_code != this.new_codeOk) {
					this.$toast(this.$t('Tips.buyizhi'));
				} else {
					this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 0,
					});

					userApi
						.setSafety(this.new_code, this.after_code)
						.then((data) => {
							console.log(data.data);
							this.$toast.clear();
							this.$toast.success(this.$t('gunqq'));
							// this.PopAlert = true;
						})
						.catch((err) => {
							this.$toast.clear();
							this.$toast.fail(err.msg);
						});
				}
			},
		},
		mounted() {},
		created() {
			this.setCode = this.$route.query.isTrue;
		},
	};
</script>
<style lang="less" scoped>
	/deep/.van-field__control {
		color: #181414;
	}

	/deep/.van-button--primary {
		color: var(--van-button-primary-color);
		background: #333;
		border: var(--van-button-border-width) solid #333;
	}

	/deep/.van-cell {
		position: relative;
		display: flex;
		box-sizing: border-box;
		width: 100%;
		padding: 10px 16px;
		overflow: hidden;
		color: #181414;
		font-size: 14px;
		line-height: 37px;
		background-color: unset;
		text-align: left;
	}

	.van-field__body {
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	/deep/.van-field__body {
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	/deep/.van-cell__value {
		border-color: rgb(229, 229, 229);
		background-color: rgb(255, 255, 255);
		display: flex;
		box-sizing: border-box;
		flex-direction: row;
		align-items: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
	}

	.g-content {
		padding: 15px;
	}



	.settingwarp {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.lock-bg {
		position: relative;
		text-align: center;
		width: 9rem;
		height: 6rem;
		margin: 0 auto;
		margin-top: 1.8rem;
		background: url(../assets/image/anquanma.png) no-repeat center center;
		background-size: 100% 100%;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: reverse;
		-ms-flex-direction: column-reverse;
		flex-direction: column-reverse;
		padding: 0.6rem 0.2rem;
	}

	.paycode {
		margin-top: 0.2rem;
	}

	.van-number-keyboard {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 100;
		width: 100%;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
		background-color: #1a243f;
		-webkit-user-select: none;
		user-select: none;
	}

	.tips {
		width: 8.4rem;
		display: flex;
		margin: 0.4rem auto 1rem;
		align-items: flex-start;
		font-size: 0.35rem;

		img {
			width: 0.4rem;
			margin-right: 0.12rem;
		}
	}

	.c_a0a0a0 {
		color: #a0a0a0;
	}

	// .addtitle {
	// 	color: #fff;
	// }

	.van-cell::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #3d5179;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.finish-btn {
		margin-top: auto;
		margin-bottom: 0.4rem;
		padding: 0.2rem;
	}

	.Btnlogin {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		text-align: center;
		text-decoration: none;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: transparent;
		overflow: hidden;
		/* color: #000; */
		color: #b8a78a;
		/* background-color: #f8f8f8; */
		cursor: pointer;
		/* color: #fff; */
		/* background-color: #7d58c6; */
		/* border: 1px solid #7d58c6; */
	}
</style>